export default [
    {
        label:'Name',
        placeholder:'Please enter',
        key:'name',
        value:'',
        tip:'Please enter name'
    },
    {
        label:'Hospital',
        placeholder:'Please enter',
        key:'hospital',
        tip:'Please enter hospital'
    },
    {
        label:'Department',
        placeholder:'Please enter',
        key:'department',
        tip:'Please enter department'
    },
    {
        label:'Mobile',
        placeholder:'Please enter',
        key:'mobile',
        type:'number',
        tip:'Please enter mobile'
    },
    {
        label:'Email',
        placeholder:'Please enter',
        key:'email',
        tip:'Please enter email'
    }
]
